import { postRequest } from 'data/requests/postRequest';
import isLoggedIn from '../../../helpers/auth/isLoggedIn';
import { IProductRequest } from 'data/requests/product/data/formProductRequest';

const toCartRequest = (data: IProductRequest, quoteIdMask: string) =>
    postRequest({
        method: 'POST',
        type: 'response',
        url: isLoggedIn() ? `carts/mine/items` : `guest-carts/${quoteIdMask}/items`,
        data,
    });

export default toCartRequest;
